import { Toaster as Sonner } from 'sonner';

const Toaster = () => {
  return (
    <Sonner
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        duration: 3000,
        style: {
          fontSize: '14px',
        },
      }}
    />
  );
};

export { Toaster };
